import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { ensureMetaPixel } from './hooks/useMetaPixel';
// PERF: open the connections for the webfont hosts immediately. The Google
// Fonts CSS is imported from index.css, which then has to fetch the font files
// from a SECOND origin (fonts.gstatic.com) — a serial round trip that delays
// first paint of the headings. Preconnecting removes the DNS/TLS wait.
(function preconnectFonts() {
  if (typeof document === 'undefined') return;
  const origins = [['https://fonts.googleapis.com', false], ['https://fonts.gstatic.com', true]] as const;
  for (const [href, crossOrigin] of origins) {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = href;
    if (crossOrigin) link.crossOrigin = '';
    document.head.appendChild(link);
  }
})();
// Fire the Meta Pixel (init + PageView) as early as the bundle executes —
// before React renders — so Landing Page Views are captured even when a
// slow-mobile visitor bounces before the app mounts.
ensureMetaPixel();
render(<App data-id="element-229" data-mp="15mvmr2d61t1u" />, document.getElementById('root'));